import * as Sentry from '@sentry/react';

const trackStructEvent = (category, event, id, labeledData) => {
  Object.keys(labeledData).forEach(key => {
    window.ua(
      'trackStructEvent', // Snowplow tracking type
      category, // Category
      event, // Event
      String(id), // ID
      key, // Labeled metrics (values needs to be number-formats)
      String(labeledData[key])
    );
  });
};

const trackStructEventWithoutValue = (
  category,
  event,
  id,
  labeledData,
  data
) => {
  Object.keys(labeledData).forEach(key => {
    window.ua(
      'trackStructEvent', // Snowplow tracking type
      category, // Category
      event, // Event
      String(id), // ID
      String(labeledData[key]),
      //  key,
      [
        {
          schema: 'iglu:it.uniid/cart/jsonschema/1-0-1',
          data
        }
      ]
    );
  });
};

const trackCheckout = (data, pageType, productArr) => {
  const modifiedData = { ...data };
  let mappedProducts = [];
  if (productArr && productArr.length > 0) {
    mappedProducts = productArr.map(product => {
      return {
        id: product.line_id.toString() || '',
        product_id: product.product_id.toString() || '',
        quantity: product.quantity.toString() || '',
        size: product.size || ''
      };
    });
    modifiedData.cart_items = mappedProducts;
  }
  modifiedData.customer_id = modifiedData.customer_id.toString();
  modifiedData.order_id = modifiedData.order_id.toString();
  if ('ua' in window) {
    window.ua('trackPageView', null, [
      {
        schema: 'iglu:it.uniid/page/jsonschema/1-0-0',
        data: { pageType: pageType || '' }
      },
      {
        schema: 'iglu:it.uniid/cart/jsonschema/1-0-1',
        data: modifiedData
      }
    ]);
    return true;
  }
  return false;
};

const trackPageView = pageType => {
  if ('ua' in window) {
    return window.ua('trackPageView', null, [
      {
        schema: 'iglu:it.uniid/page/jsonschema/1-0-0',
        data: { pageType: pageType || '' }
      }
    ]);
  }
  return false;
};

function getDuid(cookieName) {
  const newCookieName = cookieName || '_ua_';
  const matcher = new RegExp(`${newCookieName}id\\.[a-f0-9]+=([^;]+);?`);
  const match = document.cookie.match(matcher);
  if (match && match[1]) {
    return match[1].split('.')[0];
  }
  return false;
}

function trackInputValidationError(category, inputName, inputValue) {
  // Notify Snowplow about validation failures without blocking the thread.
  // https://github.com/snowplow/snowplow/wiki/2-Specific-event-tracking-with-the-Javascript-tracker#371-trackstructevent
  setTimeout(() => {
    try {
      window.ua(
        'trackStructEvent',
        category,
        'input-validation-failed',
        inputName,
        inputValue
      );
    } catch (error) {
      Sentry.captureException(error);
    }
  }, 0);
}

export {
  trackStructEvent,
  trackPageView,
  trackCheckout,
  trackInputValidationError,
  trackStructEventWithoutValue
};
export default getDuid;
